import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { PLAYER_ACTION_BUTTON_SIZE } from "../Player/Player.constants";
import { getProps } from "./ToggleSpeaker.utilities";
import { ToggleSpeakersProps } from "./ToggleSpeakers.decl";

export function ToggleSpeakers({ mode, setMode }: ToggleSpeakersProps) {
  const { t } = useTranslation();

  const isKaraoke = mode === "karaoke";
  const { icon: Icon, tooltip } = getProps(isKaraoke);

  const handleOnClick = () => {
    if (isKaraoke) {
      setMode("simple");
    } else {
      setMode("karaoke");
    }
  };
  const dataTest = `toggle-speakers-button-${isKaraoke ? "collapse" : "expand"}`;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            onClick={handleOnClick}
            data-test={dataTest}
            variant="ghost"
            size={PLAYER_ACTION_BUTTON_SIZE}
            aria-label={t(tooltip)}
          />
        }
      >
        {/* No size class: the DS icon-lg token sizes the glyph. */}
        <Icon />
      </TooltipTrigger>
      <TooltipContent>{t(tooltip)}</TooltipContent>
    </Tooltip>
  );
}
